import { render, staticRenderFns } from "./UploadedOtherCertificates.vue?vue&type=template&id=d6a90cec&scoped=true&"
import script from "./UploadedOtherCertificates.vue?vue&type=script&lang=js&"
export * from "./UploadedOtherCertificates.vue?vue&type=script&lang=js&"
import style0 from "./UploadedOtherCertificates.vue?vue&type=style&index=0&id=d6a90cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a90cec",
  null
  
)

export default component.exports